import {
  AiOutlineFacebook,
  AiOutlineInstagram,
  AiOutlineLinkedin,
  AiOutlineTwitter,
  AiOutlineYoutube,
} from 'react-icons/ai';
import {
  Button,
  Col,
  Image,
  Layout,
  Row,
  Space,
  Tooltip,
  Typography,
} from 'antd';

import { AppDefaults } from 'config/global-enums';
import { Link, useNavigate } from 'react-router-dom';
import { LinkWrapper } from './LinkWrapper';
import { isMobile } from 'react-device-detect';
import moment from 'moment';
import { navMenuItems } from './PublicNavbar';
import { selectTheme } from 'styles/theme/slice/selectors';
import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import HomeNewDemoSection from 'modules/Home/components/HomeComponents/HomeNewDemoSection';

const { Footer } = Layout;
const { Title, Text } = Typography;

export const customFooterPolicyItems = [
  {
    key: '/terms-of-use',
    label: 'Terms of Use',
  },
  {
    key: '/privacy-policy',
    label: 'Privacy',
  },
  {
    key: '/cookies-policy',
    label: 'Cookies',
  },
  {
    key: '/payment-policy',
    label: 'Payment',
  },
];

export const customFooterProductsItems = [
  {
    key: '/products/magics',
    label: 'Magics',
  },
  // {
  //   key: '/products/carma',
  //   label: 'Carma',
  // },
  {
    key: '/products/craft',
    label: 'Craft',
  },
];

export const customFooterSolutionsItems = [
  {
    key: '/solutions/isp',
    label: 'ISP',
  },
  {
    key: '/solutions/ecommerce',
    label: 'Ecommerce',
  },
  {
    key: '/solutions/websites',
    label: 'Business Websites',
  },
  {
    key: '/solutions/wordpress',
    label: 'Wordpress',
  },
];

export const customFooterChannelsItems = [
  {
    key: '/solutions/channels/instagram',
    label: 'Instagram',
  },
  {
    key: '/solutions/channels/facebook-messenger',
    label: 'Facebook Messenger',
  },
  {
    key: '/solutions/channels/web-widget',
    label: 'Web Widget',
  },
  {
    key: '/solutions/channels/whatsapp-business-api',
    label: 'Whatsapp Business API',
  },
];

export default function CustomFooter() {
  const customTheme = useSelector(selectTheme);
  const navigate = useNavigate();

  const ColWrapper = useCallback(
    ({ children }) => (
      <Col
        span={6}
        xs={{ span: 24, offset: 0 }}
        md={{ span: 12, offset: 0 }}
        lg={{ span: 4, offset: 0 }}
      >
        {children}
      </Col>
    ),
    [],
  );

  const SocialLinkWrapper = ({ children, toPath }) => (
    <a
      href={toPath}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: '#fafafa', display: 'flex', alignItems: 'center' }}
    >
      {children}
    </a>
  );

  const AuthLinkWrapper = ({ children, navigateTo }) => (
    <Button
      type="text"
      style={{
        border: 'none',
        background: 'none',
        padding: 0,
        height: '25px',
        color: '#fafafa',
      }}
      onClick={() => {
        navigate(navigateTo);
      }}
    >
      {children}
    </Button>
  );

  return (
    <>
      <HomeNewDemoSection />
      <Footer
        style={{
          backgroundColor: '#181818',
          padding: '60px 24px 24px 24px',
        }}
      >
        <div
          style={{
            maxWidth: '1256px',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          <Row gutter={[16, 20]}>
            <ColWrapper
              span={6}
              xs={{ span: 24, offset: 0 }}
              md={{ span: 12, offset: 0 }}
              lg={{ span: 6, offset: 0 }}
            >
              <a href="/" target="_blank" rel="noopener noreferrer">
                <Image
                  width={100}
                  preview={false}
                  className="logo-img-styles"
                  src="/logo-white.png?x=10000000"
                  alt="clean logo with text"
                />
              </a>
            </ColWrapper>
            <ColWrapper
              span={6}
              xs={{ span: 24, offset: 0 }}
              lg={{ span: 6, offset: 0 }}
            >
              <Title level={5} style={{ color: '#fafafa' }}>
                General
              </Title>
              <Space direction="vertical">
                <AuthLinkWrapper navigateTo="/signin">Sign in</AuthLinkWrapper>
                <AuthLinkWrapper navigateTo="/signup">Sign up</AuthLinkWrapper>
                {navMenuItems.map(
                  navEl =>
                    !navEl.hideInFooter && (
                      <LinkWrapper
                        key={navEl.key}
                        toPath={navEl.key}
                        disableNewTab={!navEl.openInNew}
                      >
                        {navEl.label}
                      </LinkWrapper>
                    ),
                )}
                <SocialLinkWrapper toPath="https://docs.cleandesk.ai">
                  Developers
                </SocialLinkWrapper>
                <SocialLinkWrapper toPath="https://blogs.cleandesk.ai">
                  Blogs
                </SocialLinkWrapper>
                <LinkWrapper toPath="/case-studies" disableNewTab>
                  Case Study
                </LinkWrapper>
              </Space>
            </ColWrapper>
            <ColWrapper
              span={6}
              xs={{ span: 24, offset: 0 }}
              lg={{ span: 6, offset: 0 }}
            >
              <Title level={5} style={{ color: '#fafafa' }}>
                Products
              </Title>
              <Space direction="vertical">
                {customFooterProductsItems.map(navEl => (
                  <LinkWrapper
                    key={navEl.key}
                    toPath={navEl.key}
                    disableNewTab={!navEl.openInNew}
                  >
                    {navEl.label}
                  </LinkWrapper>
                ))}
              </Space>

              <Title level={5} style={{ marginTop: '9px', color: '#fafafa' }}>
                Channels
              </Title>
              <Space direction="vertical">
                {customFooterChannelsItems.map(navEl => (
                  <LinkWrapper
                    key={navEl.key}
                    toPath={navEl.key}
                    disableNewTab={!navEl.openInNew}
                  >
                    {navEl.label}
                  </LinkWrapper>
                ))}
              </Space>
            </ColWrapper>
            <ColWrapper
              span={6}
              xs={{ span: 24, offset: 0 }}
              lg={{ span: 6, offset: 0 }}
            >
              <Title level={5} style={{ color: '#fafafa' }}>
                Solutions
              </Title>
              <Space direction="vertical">
                {customFooterSolutionsItems.map(navEl => (
                  <LinkWrapper
                    key={navEl.key}
                    toPath={navEl.key}
                    disableNewTab={!navEl.openInNew}
                  >
                    {navEl.label}
                  </LinkWrapper>
                ))}
              </Space>
            </ColWrapper>
            <ColWrapper
              span={6}
              xs={{ span: 24, offset: 0 }}
              lg={{ span: 6, offset: 0 }}
            >
              <Title level={5} style={{ color: '#fafafa' }}>
                Policies
              </Title>
              <Space direction="vertical">
                {customFooterPolicyItems.map(navEl => (
                  <LinkWrapper key={navEl.key} toPath={navEl.key}>
                    {navEl.label}
                  </LinkWrapper>
                ))}
              </Space>
            </ColWrapper>
            <ColWrapper
              span={6}
              xs={{ span: 24, offset: 0 }}
              lg={{ span: 6, offset: 0 }}
            >
              <Title level={5} style={{ color: '#fafafa' }}>
                Social
              </Title>
              <Space direction="vertical">
                <SocialLinkWrapper toPath="https://www.facebook.com/people/CleanDesk/100088697928624/">
                  <AiOutlineFacebook /> Facebook
                </SocialLinkWrapper>

                <SocialLinkWrapper toPath="https://www.linkedin.com/company/cleandesk-in/">
                  <AiOutlineLinkedin /> Linkedin
                </SocialLinkWrapper>
                <SocialLinkWrapper toPath="https://www.instagram.com/cleandesk_ai">
                  <AiOutlineInstagram /> Instagram
                </SocialLinkWrapper>
                <SocialLinkWrapper toPath="https://twitter.com/CleanDesk_Ai/">
                  <AiOutlineTwitter /> Twitter
                </SocialLinkWrapper>
                <SocialLinkWrapper toPath="https://www.youtube.com/@CleanDeskAI">
                  <AiOutlineYoutube /> Youtube
                </SocialLinkWrapper>

                {/* <SocialLinkWrapper toPath="https://www.instagram.com/foop/">
                  <AiOutlineInstagram /> Instagram
                </SocialLinkWrapper>

                <SocialLinkWrapper toPath="https://twitter.com/foopnetree?lang=en">
                  <AiOutlineTwitter /> Twitter
                </SocialLinkWrapper>

                <SocialLinkWrapper toPath="https://www.youtube.com/channel/UCRHOp2HlUmpAOZ-vm4P7LeQ">
                  <AiOutlineYoutube />
                  &nbsp;Youtube
                </SocialLinkWrapper> */}
              </Space>
            </ColWrapper>
          </Row>
        </div>
      </Footer>
      <Footer
        style={{
          backgroundColor: '#000000',
          color: '#fafafa',
        }}
      >
        <Row justify="center">
          <Col span={{ xs: { span: 24 }, lg: { span: 6 } }}>
            Copyright ©{moment().format('YYYY')}&nbsp;
          </Col>
          <Col span={{ xs: { span: 24 }, lg: { span: 6 } }}>
            {!isMobile && '| '}All rights reserved by{' '}
            <Link to="/">
              <strong>{AppDefaults.COMPANY_NAME}</strong>
            </Link>
            &nbsp;
          </Col>
          <Col
            span={{ xs: { span: 24 }, lg: { span: 6 } }}
            style={{ cursor: 'pointer' }}
          >
            <Text style={{ color: '#fafafa' }}>
              <Tooltip
                title={
                  AppDefaults.APP_BUILD > 0 && `Build(${AppDefaults.APP_BUILD})`
                }
              >
                {!isMobile && '| '}Version {AppDefaults.APP_VERSION}
              </Tooltip>
            </Text>
          </Col>
        </Row>
      </Footer>
    </>
  );
}
